import { Select } from "discover.medical.react-component-library";
import styled from "styled-components";

export const StyledFiltersWrapper = styled.div`
  display: block;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
  }
`;

export const StyledFilter = styled(Select)`
  width: 12rem;
  flex: 0 0 12rem;
  margin-right: ${({ theme }) => theme.space.md};
`;

export const StyledSortWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.space.sm};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 0;
  }
`;

export const StyledSortSelect = styled(Select)`
  flex: 0 0 9rem;
  margin-left: ${({ theme }) => theme.space.sm};
`;
